import colors from "tailwindcss/colors";

import { formatNumberWithSuffix } from "./hooks/utils";

import { formatSpacedCategoryAxisLabel } from "@/utils/dateAxisCategoryLabels";

export const fillColors = [
  colors.blue[300],
  colors.blue[400],
  colors.blue[500],
  colors.blue[600],
  colors.indigo[300],
  colors.indigo[400],
  colors.indigo[500],
  colors.indigo[600],
  colors.purple[400],
  colors.purple[500],
  colors.purple[600],
  colors.cyan[400],
  colors.cyan[500],
  colors.cyan[600],
  colors.violet[400],
  colors.violet[500],
  colors.violet[600],
].filter(Boolean) as string[];

export const strokes = [
  colors.blue[300],
  colors.blue[400],
  colors.blue[500],
  colors.blue[600],
  colors.indigo[300],
  colors.indigo[400],
  colors.indigo[500],
  colors.indigo[600],
  colors.purple[400],
  colors.purple[500],
  colors.purple[600],
  colors.cyan[400],
  colors.cyan[500],
  colors.cyan[600],
  colors.violet[400],
  colors.violet[500],
  colors.violet[600],
].filter(Boolean) as string[];

export const gradientFills = fillColors.map(c => `${c}40`);

const getCssVarColor = (varName: string, fallback: string) => {
  if (typeof window === "undefined") {
    return fallback;
  }
  const raw = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
  return raw ? `hsl(${raw})` : fallback;
};

const axisLabelColor = getCssVarColor("--muted-foreground", "#6b7280");
const axisLineColor = getCssVarColor("--border", "#e5e7eb");
const gridStrokeColor = getCssVarColor("--muted", "#f3f4f6");

export const DEFAULT_BASE_CHART_CONFIG = {
  background: {
    fill: "transparent",
  },
  legend: {
    enabled: false,
  },
  axes: [
    {
      type: "category" as const,
      position: "bottom" as const,
      label: {
        fontSize: 11,
        color: axisLabelColor,
        formatter: (params: { value: unknown; index: number }) =>
          formatSpacedCategoryAxisLabel({
            datapointCount: 0,
            value: params.value,
            index: params.index,
          }),
        wrapping: "never",
      },
      line: {
        color: axisLineColor,
      },
      tick: {
        color: axisLineColor,
      },
    },
    {
      type: "number" as const,
      position: "left" as const,
      label: {
        fontSize: 11,
        color: axisLabelColor,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        formatter: (params: any) => formatNumberWithSuffix(params.value),
      },
      line: {
        color: axisLineColor,
      },
      tick: {
        color: axisLineColor,
      },
      gridStyle: [
        {
          stroke: gridStrokeColor,
          strokeWidth: 1,
        },
      ],
    },
  ],
  highlight: {
    bringToFront: true,
  },
  tooltip: {
    mode: "shared",
    range: "nearest",
    tracking: true,
    class: "ag-charts-tooltip",
  },
  theme: {
    palette: {
      fills: fillColors,
      strokes: strokes,
    },
    overrides: {
      bar: {
        series: {
          strokeWidth: 0,
          cornerRadius: 15,
        },
      },
      line: {
        series: {
          highlight: {
            highlightedSeries: {
              strokeWidth: 2,
            },
          },
        },
      },
    },
  },
};
